<template>
  <page-content-placeholder
    icon="check"
    icon-color="success"
    prompt-text="Complete"
  >
    <template #message>
      All references awaiting you have been screened.
    </template>
  </page-content-placeholder>
</template>

<script>
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';

export default {
  name: 'ScreenTabAwaitingYouEmptyState',
  components: {
    PageContentPlaceholder,
  },
};
</script>
